<template>
  <div class="context-help-content">
    <v-layout justify-center>
      <v-progress-circular indeterminate v-if="loading && !error"></v-progress-circular>
    </v-layout>
    <div v-html="helpHtml" v-if="!loading && !error && !editando"></div>
    <ErrorMessage v-if="error" @refresh="getHelp()" :message="errorMessage"/>
  </div>
</template>

<script>
  import ErrorMessage from '../utils/ErrorMessage';
  import HtmlInput from '../HtmlInput';

  export default {
    name: 'ContextHelpContent',
    components: {HtmlInput, ErrorMessage},
    props: {
      path: {
        type: String,
        required: true,
      },
      baseUrl: {
        default: () => 'ayuda',
      },
    },
    data: () => ({
      loading: false,
      error: false,
      helpHtml: null,
      errorMessage: 'No se pudo obtener el contenido',
      editando: false,
    }),
    mounted () {
      this.getHelp();
    },
    methods: {
      async getHelp () {
        this.loading = true;
        this.error = false;
        try {
          const r = await this.$http.get(`${process.env.VUE_APP_ROOT_API}${this.baseUrl}/`, {
            params: {
              filter: [`path:${encodeURIComponent(this.path)}:eq`]
            },
          });
          const list = await r.json();
          this.helpHtml = list.length > 0 ? list[0].contenidoAyuda: '<p>Sin ayuda para este componente.</p>';
          this.id = list[0] ? list[0].id : null;
        } catch (error) {
          this.error = true;
        } finally {
          this.loading = false;
        }
      },
    },
    watch: {
      helpHtml() {
        this.$emit('change', this.helpHtml);
      },
    },
  };
</script>

<style scoped>

</style>
